/** Client-side checks only; server must enforce full validation. */

export const MAX_IMAGE_UPLOAD_BYTES = 20 * 1024 * 1024;

/** Must stay aligned with backend accepted image MIME types. */
export const ALLOWED_IMAGE_MIMES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/x-icon',
  'image/svg+xml',
]);

/** Lowercase extensions aligned to ALLOWED_IMAGE_MIMES. */
export const ALLOWED_IMAGE_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.bmp',
  '.ico',
  '.svg',
];

export const IMAGE_UPLOAD_ACCEPT = [
  ...ALLOWED_IMAGE_EXTENSIONS,
  ...ALLOWED_IMAGE_MIMES,
].join(',');

function hasAllowedImageExtension(fileName) {
  const lower = String(fileName || '').toLowerCase();
  return ALLOWED_IMAGE_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

/**
 * @param {File|Blob|null} file
 * @returns {string|null} Error message, or null if no client-side error (including when not a File).
 */
export function getImageUploadClientError(file) {
  if (!file || !(file instanceof File)) {
    return null;
  }
  if (file.size > MAX_IMAGE_UPLOAD_BYTES) {
    return 'File size must not exceed 20 MB.';
  }
  if (!hasAllowedImageExtension(file.name)) {
    return 'Only supported image types are allowed.';
  }
  if (file.type && !ALLOWED_IMAGE_MIMES.has(file.type)) {
    return 'Only supported image types are allowed.';
  }
  return null;
}
